import Modal from '../../../../components/modal/modal';

import styles from './deactivate-operator-modal.module.scss';

type Props = {
    shown: boolean;
    onConfirm: () => void;
    onDiscard: () => void;
};

const DeactivateOperatorModal = ({ shown, onConfirm, onDiscard }: Props) => (
    <Modal shown={shown} onDiscard={onDiscard}>
        <div className={styles.modal}>
            <h4>Eliminar operador</h4>
            <span>¿Estás seguro que quieres eliminar este operador?</span>
            <div className={styles.actions}>
                <button className={styles.discard} onClick={onDiscard}>
                    Cerrar este modal
                </button>
                <button className={styles.confirm} onClick={onConfirm}>
                    Desactivar operador
                </button>
            </div>
        </div>
    </Modal>
);

export default DeactivateOperatorModal;
